import { ScheduledPostTarget } from 'types'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { getTargetActionConfig } from '../utils/getTargetActionConfig'
import type { ActionType } from '../utils/getTargetActionConfig'
import { ValidationResult } from 'utils/validateScheduledPost'

type PassthroughType = Extract<ActionType, 'view-post' | 'post-now' | 'retry' | 'retry-auth' | 'posting' | 'loading'>

const PASSTHROUGH_TYPES: ReadonlySet<ActionType> = new Set<PassthroughType>([
  'view-post',
  'post-now',
  'retry',
  'retry-auth',
  'posting',
  'loading',
])

export type PostedRowActionType = PassthroughType | 'view-post-disabled'

export interface PostedRowAction {
  type: PostedRowActionType
  onPress?: () => void
  tooltip?: string
  errorMessage?: string
}

interface GetPostedRowActionParams {
  platform: ExternalIntegrationEnum
  target?: ScheduledPostTarget
  validation: ValidationResult
  hasTarget: boolean
  needsReauth?: boolean
  onPublish: (targetId: number) => void
  onPublishWithoutTarget: () => void
  onViewPost: (url: string) => void
}

const noop = () => undefined

export const getPostedRowAction = (params: GetPostedRowActionParams): PostedRowAction | null => {
  const { target } = params

  if (target?.status === 'published' && !target.post_url) {
    return { type: 'view-post-disabled', tooltip: 'Post URL unavailable' }
  }

  const config = getTargetActionConfig({
    ...params,
    isAvailable: true,
    isAlreadyPosted: true,
    onRetry: params.onPublish,
    onConnect: noop,
    onToggle: noop,
    onReauth: noop,
  })

  if (!PASSTHROUGH_TYPES.has(config.type)) {
    return null
  }

  return {
    type: config.type as PassthroughType,
    onPress: config.onPress,
    tooltip: config.buttonTooltip,
    errorMessage: config.componentTooltip,
  }
}
